import http from './http'

/**
 * 获取提现配置
 * @returns {Promise} 返回提现配置信息（最低提现金额、手续费率等）
 */
export const getWithdrawConfig = () => {
  return http.get('/devWithdraw/config')
}

/**
 * 申请提现
 * @param {Object} params - 提现申请参数
 * @param {number} params.withdrawMoney - 提现金额
 * @param {string} params.usdtAddress - USDT TRC20地址
 * @param {string} [params.remark] - 用户备注
 * @returns {Promise} 返回提现记录ID
 */
export const applyWithdraw = (params) => {
  return http.post('/devWithdraw/apply', params)
}

/**
 * 取消提现
 * @param {Object} params - 取消提现参数
 * @param {number} params.id - 提现记录ID
 * @param {string} [params.reason] - 取消原因
 * @returns {Promise}
 */
export const cancelWithdraw = (params) => {
  return http.post('/devWithdraw/cancel', params)
}

/**
 * 查询我的提现记录列表
 * @param {Object} params - 查询参数
 * @param {number} [params.page] - 页码
 * @param {number} [params.pageSize] - 每页数量
 * @param {number} [params.status] - 状态筛选（0待审核 1审核通过 2已打款 3已完成 4已驳回 5已取消）
 * @returns {Promise} 返回提现记录列表
 */
export const getWithdrawList = (params) => {
  return http.post('/devWithdraw/list', params)
}

/**
 * 查询提现详情
 * @param {number} id - 提现记录ID
 * @returns {Promise} 返回提现记录详情
 */
export const getWithdrawDetail = (id) => {
  return http.get('/devWithdraw/detail', { params: { id } })
}

/**
 * 提现状态枚举
 */
export const WithdrawStatus = {
  PENDING: 0,        // 待审核
  APPROVED: 1,       // 审核通过
  PAID: 2,           // 已打款
  COMPLETED: 3,      // 已完成
  REJECTED: 4,       // 已驳回
  CANCELLED: 5       // 已取消
}

/**
 * 提现状态文本映射
 */
export const WithdrawStatusText = {
  0: 'withdraw.status.pending',
  1: 'withdraw.status.approved',
  2: 'withdraw.status.paid',
  3: 'withdraw.status.completed',
  4: 'withdraw.status.rejected',
  5: 'withdraw.status.cancelled'
}

/**
 * 提现状态颜色映射（用于UI展示）
 */
export const WithdrawStatusColor = {
  0: 'warning',   // 待审核 - 黄色
  1: 'primary',   // 审核通过 - 蓝色
  2: 'info',      // 已打款 - 蓝灰色
  3: 'success',   // 已完成 - 绿色
  4: 'danger',    // 已驳回 - 红色
  5: 'info'       // 已取消 - 灰色
}
